import { isFacetVisible } from '../../types.js';
import { useAlgoliaConfig } from '../AlgoliaConfig.js';

function useItemsToClear(items) {
    const { facets  } = useAlgoliaConfig();
    const visibleFacets = facets.filter(isFacetVisible);
    return items.filter((item)=>visibleFacets.find(({ attribute  })=>attribute === item.attribute
        )
    );
}

export { useItemsToClear };
//# sourceMappingURL=use-items-to-clear.js.map
